import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { PlusIcon } from "lucide-react";
import { faqs } from "../../data/content";
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section id="questions" aria-labelledby="questions-title" className="on-light scroll-mt-20 border-t border-navy/10 bg-ice" data-id="element-106" data-mp="zrqb3at93dgp">
      <div className="container-x grid gap-10 py-14 sm:py-20 lg:grid-cols-12 lg:gap-16 lg:py-28" data-id="element-107" data-mp="70os0ymfsxrw">
        <div className="lg:col-span-4" data-id="element-108" data-mp="22n7e99d4qeb">
          <p className="eyebrow" data-id="element-109" data-mp="23ooovgz294h">Questions</p>
          <h2 id="questions-title" className="section-title mt-4" data-id="element-110" data-mp="gz4m9agrgn5m">
            Before you <span className="text-navy underline decoration-cyan decoration-[4px] underline-offset-[6px]" data-id="element-111" data-mp="gx1m3xlw9dn6">plan with it</span>
          </h2>
          <p className="mt-6 max-w-[26rem] text-[17px] leading-[1.7] text-body" data-id="element-112" data-mp="1sdrunndsihjy">
            Straight answers about what the book includes, and what it isn’t.
          </p>
        </div>

        <ul className="border-t-2 border-cyan lg:col-span-8" data-id="element-113" data-mp="hu8xr4v12yle">
          {faqs.map((faq, i) => {
          const open = openIndex === i;
          return <li key={faq.question} className="border-b border-navy/10" data-id="element-114" data-mp="muwu862107n0" data-mpi={i}>
                <h3 data-id="element-115" data-mp="rsevrbdprkkz">
                  <button type="button" id={`faq-button-${i}`} aria-expanded={open} aria-controls={`faq-panel-${i}`} onClick={() => setOpenIndex(open ? null : i)} className="flex w-full items-center justify-between gap-4 py-5 text-left text-[16px] font-bold text-navy sm:gap-6 sm:py-6 sm:text-lg" data-id="element-116" data-mp="rpst9q5ojv9m">
                    <span data-id="element-117" data-mp="cv640gki0esq">{faq.question}</span>
                    <span className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full border transition-[transform,background-color,border-color,color] duration-200 ease-out ${open ? "rotate-45 border-cyan bg-cyan text-navy" : "border-cyan bg-white text-cyan-deep"}`} aria-hidden="true" data-id="element-118" data-mp="cvxoav8naq3p">
                      <PlusIcon className="h-4 w-4" data-id="element-119" data-mp="iobowkriho2c" />
                    </span>
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-120" data-mp="sffs6n7trkhc">
                  {open && <motion.div id={`faq-panel-${i}`} role="region" aria-labelledby={`faq-button-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: "auto",
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-121" data-mp="4qddno8hm7r2">
                      <p className="max-w-[62ch] pb-6 pr-2 text-[15px] leading-relaxed text-body sm:pb-7 sm:pr-12 sm:text-base" data-id="element-122" data-mp="1l4n36logu2jh">{faq.answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}